import React from 'react';
import { motion } from 'framer-motion';
interface SecondaryButtonProps {
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  icon?: ReactNode;
}
export function SecondaryButton({
  children,
  onClick,
  disabled = false,
  className = '',
  icon
}: SecondaryButtonProps) {
  return <motion.button whileTap={disabled ? {} : {
    scale: 0.97
  }} onClick={onClick} disabled={disabled} className={`w-full min-h-[48px] rounded-lg font-semibold text-base flex items-center justify-center gap-2 transition-colors border-2 ${disabled ? 'border-slate-800 text-slate-600 cursor-not-allowed' : 'border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-white'} ${className}`} data-id="element-1089">
      {icon}
      {children}
    </motion.button>;
}